import { z } from 'zod';
import { orderCvxSchema } from './orderSchema';

/**
 * Stored row of `ordersArchived`: every order shape ever archived. The archive is never migrated,
 * so its rows are read only through `orderCvxSchema.parse`, which fills fields added since with
 * their `.default()` and strips fields removed since. Queries return `OrderCvx`, never this.
 *
 * Wider than `orderCvxSchema`, so Convex's deploy-time check accepts every older row:
 * - Field added: nothing to do. Every field is optional here, nested ones too. Give it a
 *   `.default()`, or older rows fail the parse.
 * - Field removed, or its type narrowed: keep the old definition here. Unlike other `*CvxSchema`s,
 *   this one may hold fields `orderSchema` lacks.
 * - Nested object schema added to the order: nothing to do, `z.deepPartial` makes its fields
 *   optional too.
 * - Fields the `ordersArchived` indexes cover never change.
 */
export const archivedOrderCvxSchema = z.deepPartial(orderCvxSchema);
